import { useState, useLayoutEffect } from "react";
function useElementTopOffset(ref) {
  const [offsetTop, setOffsetTop] = useState(void 0);
  useLayoutEffect(() => {
    if (!ref?.current) {
      return;
    }
    const element = ref.current;
    function updateTopOffsetCallback() {
      setOffsetTop(element.offsetTop);
    }
    function updateTopOffsetHandler() {
      requestAnimationFrame(updateTopOffsetCallback);
    }
    updateTopOffsetHandler();
    const observer = new ResizeObserver(() => {
      requestAnimationFrame(updateTopOffsetCallback);
    });
    observer.observe(element);
    return () => {
      observer.unobserve(element);
    };
  }, [ref]);
  return offsetTop;
}
export {
  useElementTopOffset
};
//# sourceMappingURL=useElementTopOffset.js.map
